var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 41.5V25.9375M41.5 53.0351V53.1719M72.625 41.5C72.625 58.6899 58.6899 72.625 41.5 72.625C24.3101 72.625 10.375 58.6899 10.375 41.5C10.375 24.3101 24.3101 10.375 41.5 10.375C58.6899 10.375 72.625 24.3101 72.625 41.5Z",
    stroke: "#FF0000",
    strokeWidth: 5.14728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleIcon);
export default __webpack_public_path__ + "static/media/alert-circle-icon.573384c18d8469c2de92a964d0a888c6.svg";
export { ForwardRef as ReactComponent };